import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a8b5502")

_pushScopeId("data-v-2a8b5502")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = {
  key: 0,
  class: "footer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.hasFooter())
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ]))
})